var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.52 19V20H3.52002V19L5.52002 17V11C5.52002 7.9 7.55002 5.17 10.52 4.29V4C10.52 3.46957 10.7307 2.96086 11.1058 2.58579C11.4809 2.21071 11.9896 2 12.52 2C13.0505 2 13.5592 2.21071 13.9342 2.58579C14.3093 2.96086 14.52 3.46957 14.52 4V4.29C17.49 5.17 19.52 7.9 19.52 11V17L21.52 19ZM14.52 21C14.52 21.5304 14.3093 22.0391 13.9342 22.4142C13.5592 22.7893 13.0505 23 12.52 23C11.9896 23 11.4809 22.7893 11.1058 22.4142C10.7307 22.0391 10.52 21.5304 10.52 21",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.dddec0858756d3bda3a1ccfdf0ebdee9.svg";
export { ForwardRef as ReactComponent };